import styled from "styled-components";
import './style.css'
import { ImCheckboxChecked } from "react-icons/im";
import { FaMinus } from "react-icons/fa";
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
// CryptoJS removido - preços agora são armazenados como números puros

const DivBGtransparent = styled.div`
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  display: ${({ addedToCart }) => (addedToCart ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  align-items: center;
  justify-content: center;
  opacity: ${({ addedToCart }) => (addedToCart ? '1' : '0')};
  transition: opacity 0.25s ease;
  animation: ${({ addedToCart }) => (addedToCart ? 'modalFadeIn 0.25s ease forwards' : 'none')};

  @keyframes modalFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const DivContainer = styled.div`
    z-index: 10000;
    position: relative;
    width: 90%;
    max-width: 420px;
    background-color: #fff;
    border-radius: 16px;
    padding: 24px 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: modalSlideUp 0.3s ease;

    @keyframes modalSlideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
`;

const ModalItemAdicionado = ({ addedToCart,
    setAddedToCart,
    setItensCarrinho,
    itensCarrinho,
    selectedItemId,
    selectedItemNome,
    showPedido, setRefresh
    //tipoImpressao
}) => {
    const { t } = useTranslation('cardapio');
    const navigate = useNavigate();
    // Obtém o external_id da URL atual, se existir
    const [searchParams] = useSearchParams();
    const externalId = searchParams.get('external_id');
    const modeParam = searchParams.get('mode');
    const isSalao = modeParam === 'salao';
    const { nomeEmpresaForUrl, idEmpresa, slug } = useParams();
    const isSlugRoute = !!slug;
    process.env.REACT_APP_ISDEVELOP === 'true' && console.log(nomeEmpresaForUrl, idEmpresa, slug);

    // 🔧 FIX: Construir URL do carrinho com suporte a slug e fallback para sessionStorage
    const buildCartUrl = () => {
        let base;
        if (isSlugRoute && slug) {
            base = `/c/${slug}/carrinho`;
        } else if (nomeEmpresaForUrl && idEmpresa) {
            base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/carrinho`;
        } else {
            // Fallback: buscar do sessionStorage
            try {
                const empresaData = sessionStorage.getItem('sessionCompany');
                if (empresaData) {
                    const parsed = JSON.parse(empresaData);
                    if (parsed?.slug) {
                        base = `/c/${parsed.slug}/carrinho`;
                    } else if (parsed?.name && parsed?.id_empresa) {
                        const nomeForUrl = parsed.name.toLowerCase().replace(/\s+/g, '-');
                        base = `/cardapio/${nomeForUrl}/${parsed.id_empresa}/carrinho`;
                    }
                }
            } catch (e) {
                console.error('[MODAL-ITEM] Erro ao construir URL:', e);
            }
            if (!base) {
                console.warn('[MODAL-ITEM] Não foi possível construir URL do carrinho');
                base = `/cardapio/${nomeEmpresaForUrl}/${idEmpresa}/carrinho`;
            }
        }
        const params = new URLSearchParams();
        if (externalId) params.set('external_id', externalId);
        if (isSalao) params.set('mode', 'salao');
        const qs = params.toString();
        return qs ? `${base}?${qs}` : base;
    };

    const handleKeepBuy = () => {
        setAddedToCart(!addedToCart);
        navigate(-1);
    }

    const calcularValorAdicionais = (gruposAdicionais) => {
        return gruposAdicionais.reduce((acc, grupo) => {
            if (grupo.calcular_maior_valor) {
                const maxAdicional = grupo.adicionais.reduce((max, adicional) => {
                    return adicional.price > max ? adicional.price : max;
                }, 0);
                return acc + maxAdicional;
            } else if (grupo.calcular_media) {
                const adicionaisSelecionados = grupo.adicionais.filter(adicional => adicional.quantity > 0);
    
                if (adicionaisSelecionados.length > 0) {
                    const somaValores = adicionaisSelecionados.reduce((sum, adicional) => {
                        return sum + (adicional.price * adicional.quantity);
                    }, 0);
                    const mediaValor = somaValores / adicionaisSelecionados.length;
                    return acc + mediaValor;
                }
                return acc;
            } else {
                return acc + grupo.adicionais.reduce((sum, adicional) => {
                    return sum + (adicional.price * adicional.quantity);
                }, 0);
            }
        }, 0);
    };

    const handleDecrementModal = (selectedItemId) => {
        setItensCarrinho(prevItens => prevItens.map(item => {
            if (item.id === selectedItemId) {
                // Ler preço base como número (compatível com formato antigo encrypted e novo número puro)
                const valorItemBase = typeof item.price === 'number' ? item.price : parseFloat(item.price) || 0;

                // Garantir que a quantidade não seja menor que 1
                const newQuantity = Math.max(item.quantity - 1, 1);

                // Calcular o valor dos adicionais
                const valorAdicionais = calcularValorAdicionais(item.grupos_adicionais_selecionados);
                process.env.REACT_APP_ISDEVELOP === 'true' && console.log("item:", item.type)
                // Adicionais são POR UNIDADE, multiplicam pela quantidade
                const newTotalValue = (valorItemBase + valorAdicionais) * newQuantity;

                // Atualizar o item com a nova quantidade e o novo valor total (número puro)
                return { ...item, quantity: newQuantity, total: newTotalValue };
            } else {
                return item;
            }
        }));
    };


    const handleIncrementModal = (selectedItemId) => {
        setItensCarrinho(prevItens => prevItens.map(item => {
            if (item.id === selectedItemId) {
                // Ler preço base como número (compatível com formato antigo encrypted e novo número puro)
                const valorItemBase = typeof item.price === 'number' ? item.price : parseFloat(item.price) || 0;

                // Incrementar a quantidade
                const newQuantity = (item.quantity || 1) + 1;

                // Calcular o valor dos adicionais
                const valorAdicionais = calcularValorAdicionais(item.grupos_adicionais_selecionados);

                // Adicionais são POR UNIDADE, multiplicam pela quantidade
                const newTotalValue = (valorItemBase + valorAdicionais) * newQuantity;

                // Atualizar o item com a nova quantidade e o novo valor total (número puro)
                return { ...item, quantity: newQuantity, total: newTotalValue };
            } else {
                return item;
            }
        }));
    };    


    return (
        <DivBGtransparent addedToCart={addedToCart}>
            <DivContainer>
                <div className="produtoAddChecked">
                    <ImCheckboxChecked />
                </div>
                <div className="divTitleItemAdicionado">
                    <span className="divTitleItemAdicionadoSpan">{selectedItemNome}</span>
                    <span className="divTitleItemAdicionadoSpan">{t('modal.itemAdded.addedToCart')}</span>
                </div>

                <div className="qtdBoxContainer">
                    <span className="quantityText">{t('modal.itemAdded.quantity')}</span>
                    <div className="qtdDataCounter">
                        <div className="downAndCounter">
                            <button style={{ background: "transparent" }} onClick={() => handleDecrementModal(selectedItemId)}>
                                <div className="trashIconCarrinho">
                                    <FaMinus style={{ color: "grey", fontSize: "16px" }} />
                                </div>
                            </button>
                            <div className="counterQtdItemCarrinho">
                                {itensCarrinho.find(item => item.id === selectedItemId)?.quantity || 1}
                            </div>
                        </div>
                        <button className="btnAddCounter" onClick={() => handleIncrementModal(selectedItemId)}>
                            <p><FaPlus style={{ fontSize: '20px' }} /></p>
                        </button>
                    </div>
                </div>

                <div className="divBtnContinueCart">
                    <button className="buttonContinue" onClick={() => handleKeepBuy()}>{t('modal.itemAdded.keepBuying')}</button>
                    <Link
                        to={buildCartUrl()}
                        state={{ fromItemAddModal: true }}
                    >
                        <button className="buttonCart">{t('modal.itemAdded.goToCart')}</button>
                    </Link>
                </div>

            </DivContainer>
        </DivBGtransparent>
    );
}

export default ModalItemAdicionado